import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, Renderer2, SimpleChange, SimpleChanges, ViewChild, ViewEncapsulation, ElementRef, NgZone } from '@angular/core';
import { NgbCalendar, NgbDate, NgbPopover, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { NotificationsService } from 'bowman-angular2-notifications';
import * as moment from 'moment'
import { Observable, Observer, timer } from 'rxjs';
import { BowmanCacheService } from 'bowman-cache';
import { SourceType } from 'src/app/control-bar-type-selector/model/source-type';
import { Action } from 'src/app/dashboard/model/action';
import { ActionTypesEnum } from 'src/app/dashboard/model/action-type.enum';
import { TimeRange } from 'src/app/dashboard/model/time-range';
import { DateRangeIntervals } from 'src/app/dashboard/old_model/date-range-intervals';
import { TypeMappingOverview } from 'src/app/data-types/model/type-mapping-overview';
import { TypeMappingComponent } from 'src/app/data-types/type-mapping/type-mapping.component';
import { BowmanLogger, BowmanLoggerService } from 'bowman-logger';
import { AbsoluteDateRangeIntervals } from 'src/app/model/absolute-date-range-intervals';
import { TimeRangeMoment } from 'src/app/model/time-range-moment';
import { UserResponse } from 'algorilla-shared-libs';

import { HelperFunctions } from 'bowman-commons';
import { TypeMappingService } from 'src/services/type-mapping.service';
import { Common } from 'src/app/dashboard/common';
import { AggregationIntervalsEnum } from 'src/app/dashboard/model/aggregation-intervals.enum';
import { WidgetCoordinates } from 'src/app/dashboard/model/widget-coordinates';
const CACHE_EXPIRE_MS = 300000;

@Component({
  selector: 'app-control-bar-time-selector',
  templateUrl: './control-bar-time-selector.component.html',
  styleUrls: ['./control-bar-time-selector.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})



export class ControlBarTimeSelectorComponent implements OnInit, OnDestroy, OnChanges {
  private log: BowmanLogger = new BowmanLogger(this._loggerService, 'ControlBarTimeSelectorComponent');
  public _instanceId: string;

  @Input() public action: Action;
  @Input() public searchButton: boolean;
  @Input() public zoomButtons: boolean;
  @Input() public content: TimeRange;
  @Input() public widgetDefaultsActive: boolean;
  @Input() public label: string = 'Time selector';
  @Input() public sourceTypes: Array<SourceType> = [];
  @Output() public contentChange: EventEmitter<TimeRange> = new EventEmitter<TimeRange>();
  @Output() public actionChange: EventEmitter<Action> = new EventEmitter<Action>();
  @Input() public disabled: boolean = false;
  @Input() public hideRelativeRanges: boolean = false;
  @Input() public placement: string;
  @Input() public rangeDisabled: boolean = false;
  @ViewChild(NgbPopover) public popover: NgbPopover;
  @ViewChild('timeSelectorElement') private timeSelectorElement: ElementRef;
  public user: UserResponse;
  public dateRangeIntervals: DateRangeIntervals = new DateRangeIntervals();
  public absoluteDateRangeIntervals: AbsoluteDateRangeIntervals = new AbsoluteDateRangeIntervals(0);
  public fromDate: NgbDate;
  public toDate: NgbDate;
  public fromTime: NgbTimeStruct;
  public toTime: NgbTimeStruct;
  public hoveredDate: NgbDate;
  private _timer: any;
  private _timerSubscription: any;
  public parsedTimeLabel: string;
  public selectedTimeRange: TimeRange;
  get getBestAggregationInterval() { return Common.getBestAggregationInterval }

  constructor(
    private calendar: NgbCalendar,
    private _ngZone: NgZone,
    private _loggerService: BowmanLoggerService,
    private _cdr: ChangeDetectorRef,
    private _typeMappingService: TypeMappingService,
    private _bowmanCacheService: BowmanCacheService,
    private _datePipe: DatePipe,
    private _renderer: Renderer2,
    private _notificationService: NotificationsService) {
    this.fromDate = calendar.getToday();
    this.toDate = calendar.getPrev(calendar.getToday(), 'd', 1);
    this._instanceId = HelperFunctions.uuid();
  }




  public useWidgetDefault() {
    this.parsedTimeLabel = 'Use widgets default';
    this.selectedTimeRange = null;
    this.content = null;
    this.contentChange.emit(this.content);
    this.actionChange.emit(new Action(ActionTypesEnum.UPDATE_VIEW, this._instanceId));
    this._cdr.detectChanges();
  }

  public onDateSelection(date: NgbDate) {
    if (!this.rangeDisabled) {
      // Uso this.selectedTimeRange in modo da non modificare this.timeRange originale, 
      // e propagare quindi il cambiamento soltanto quando sono state selezionate sia start che end
      this.selectedTimeRange.label = null;
      if (!this.fromDate && !this.toDate) {
        this.fromDate = date;
        this.selectedTimeRange.start = this.parseTimeRangeDate(date, this.fromTime);

      } else if (this.fromDate && !this.toDate && (date.after(this.fromDate) || date.equals(this.fromDate))) {
        this.toDate = date;
        this.selectedTimeRange.end = this.parseTimeRangeDate(date, this.toTime);
        this.selectedTimeRange.label = null;
        this.parsedTimeLabel = this.parseLabel(this.selectedTimeRange);
        this.content = this.selectedTimeRange;
        this.contentChange.emit(this.selectedTimeRange);
        this.actionChange.emit(new Action(ActionTypesEnum.UPDATE_VIEW, this._instanceId));
      } else {
        this.toDate = null;
        this.fromDate = date;
        this.selectedTimeRange.start = this.parseTimeRangeDate(date, this.fromTime);
      }
    } else {
      this.selectedTimeRange.label = null;
      this.fromDate = date;
      this.toDate = date;
      this.selectedTimeRange.start = this.parseTimeRangeDate(date, this.fromTime);
      this.selectedTimeRange.end = this.parseTimeRangeDate(date, this.fromTime);
      this.contentChange.emit(this.selectedTimeRange);
      this.actionChange.emit(new Action(ActionTypesEnum.UPDATE_VIEW, this._instanceId));
      this.parsedTimeLabel = this.parseLabel(this.selectedTimeRange);

    }
  }

  public isHovered(date: NgbDate) {
    return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
  }
  public isInside(date: NgbDate) {
    return date.after(this.fromDate) && date.before(this.toDate);
  }

  public isRange(date: NgbDate) {
    return date.equals(this.fromDate) || date.equals(this.toDate) || this.isInside(date) || this.isHovered(date)
  }

  public selectInterval(interval: TimeRangeMoment): void {
    TypeMappingComponent.getTypeMappingOverview(this._typeMappingService, this._bowmanCacheService).subscribe(typeMappingOverview => {
      ControlBarTimeSelectorComponent.getIntervalFromLabel(interval.label, this.sourceTypes, typeMappingOverview).subscribe(timeRange => {
        this.selectedTimeRange = timeRange;
        this.parseNgbDateRange(timeRange);
        this.parsedTimeLabel = this.parseLabel(timeRange);
        this.content = timeRange;
        this.contentChange.emit(timeRange);
        this.actionChange.emit(new Action(ActionTypesEnum.UPDATE_VIEW));
        this.popover.close();
      });
    }, err => {
      this._notificationService.error("Errors occurred selecting interval", err);
    })


  }

  private isTimerangeValid(timeRange: TimeRange): boolean {
    let isValid = false;
    if (timeRange != null && timeRange.start != null && timeRange.end != null) {
      isValid = true;
    }
    return isValid;
  }

  public updateFromTime(time: NgbTimeStruct, date: NgbDate) {
    if (this.rangeDisabled) {
      const timeRange: TimeRange = HelperFunctions.cloneObject(this.selectedTimeRange);
      timeRange.label = null;
      timeRange.start = this.parseTimeRangeDate(date, time);
      timeRange.end = this.parseTimeRangeDate(date, time);
      this.parseNgbDateRange(timeRange);
      this.selectedTimeRange = HelperFunctions.clone(timeRange);
      this.parsedTimeLabel = this.parseLabel(this.selectedTimeRange);
      this.contentChange.emit(this.selectedTimeRange);
      this.actionChange.emit(new Action(ActionTypesEnum.UPDATE_VIEW, this._instanceId));
    } else {
      const timeRange: TimeRange = HelperFunctions.cloneObject(this.selectedTimeRange);
      timeRange.label = null;
      timeRange.start = this.parseTimeRangeDate(date, time);
      timeRange.end = this.selectedTimeRange.end;
      this.parseNgbDateRange(timeRange);
      this.selectedTimeRange = HelperFunctions.cloneObject(timeRange);
      this.parsedTimeLabel = this.parseLabel(this.content);
      this.contentChange.emit(this.selectedTimeRange);
      this.actionChange.emit(new Action(ActionTypesEnum.UPDATE_VIEW, this._instanceId));
    }
    

  }
  public updateToTime(time: NgbTimeStruct, date: NgbDate) {
    const timeRange: TimeRange = HelperFunctions.cloneObject(this.selectedTimeRange);
    timeRange.label = null;
    timeRange.end = this.parseTimeRangeDate(date, time);
    timeRange.start = this.selectedTimeRange.start;
    this.parseNgbDateRange(timeRange);
    this.selectedTimeRange = timeRange;
    this.parsedTimeLabel = this.parseLabel(timeRange);
    this.content = timeRange;
    this.contentChange.emit(timeRange);
    this.actionChange.emit(new Action(ActionTypesEnum.UPDATE_VIEW, this._instanceId));
  }
  private parseNgbDateRange(timeRange: TimeRange) {
    if (timeRange != null) {
      this.fromDate = this.fromDateToNgb(timeRange.start);
      this.fromTime = this.fromTimeToNgb(timeRange.start);
      this.toDate = this.fromDateToNgb(timeRange.end);
      this.toTime = this.fromTimeToNgb(timeRange.end);
    }
  }

  public static getIntervalFromLabel(label: string, sourceTypes: Array<SourceType>, typeMappingOverview: Array<TypeMappingOverview>, timeZone?: number): Observable<TimeRange> {
    return Observable.create((observer: Observer<TimeRange>) => {
      var timeRange: TimeRange = new TimeRange();
      var absoluteDateRangeIntervals = new AbsoluteDateRangeIntervals(timeZone ? timeZone : 0);

      const relativeDateRangeIntervals = new DateRangeIntervals();
      if (sourceTypes != null && sourceTypes.length > 0 && label == 'All time') {
        var tmpMin: number = 9999999999999;
        var tmpMax: number = 0;
        sourceTypes.forEach(st => {
          typeMappingOverview.filter(tmoResult => tmoResult.name == st.name && tmoResult.timestampField == st.timestampField).map(tmo => {
            if (tmo.minTime < tmpMin && tmo.minTime > 0) {
              tmpMin = tmo.minTime;
            }
            if (tmo.maxTime > tmpMax && tmo.maxTime <= 29377814400000) {
              tmpMax = tmo.maxTime;
            }
          });
        });
        absoluteDateRangeIntervals.intervals[4].start = moment().date(tmpMin);
        absoluteDateRangeIntervals.intervals[4].end = moment().date(tmpMax);
        timeRange.label = 'All time';
        timeRange.start = new Date(tmpMin);
        timeRange.end = new Date(tmpMax);
        observer.next(timeRange);
        observer.complete();
      } else {
        absoluteDateRangeIntervals.intervals.filter(interval => interval.label == label).map(interval => {
          if (interval.label === label) {
            timeRange.label = interval.label;
            timeRange.start = interval.start.toDate();
            timeRange.end = interval.end.toDate();
          }
        });
        relativeDateRangeIntervals.intervals.filter(interval => interval.label == label).map(interval => {
          if (interval.label === label) {
            timeRange.label = interval.label;
            timeRange.start = interval.start.toDate();
            timeRange.end = interval.end.toDate();
          }
        });
        observer.next(timeRange);
        observer.complete();
      }
    });
  }

  private fromNgbToDate(inputDate: NgbDate): Date {
    const date: Date = new Date(inputDate.year + '-' + inputDate.month + '-' + inputDate.day);
    return date;

  }
  private fromNgbToTime(inputTime: NgbTimeStruct): Date {
    const date: Date = new Date();
    date.setHours(inputTime.hour);
    date.setMinutes(inputTime.minute);
    date.setSeconds(inputTime.second);
    return date;
  }
  private fromDateToNgb(inputDate: Date | string): NgbDate {
    const date: Date = new Date(inputDate);
    return new NgbDate(date.getFullYear(), date.getMonth() + 1, date.getDate());
  }
  private fromTimeToNgb(inputDate: Date | string): NgbTimeStruct {
    const date: Date = new Date(inputDate);
    return { 'hour': date.getHours(), 'minute': date.getMinutes(), 'second': date.getSeconds() };
  }

  private parseTimeRangeDate(date: NgbDate, time: NgbTimeStruct): Date {
    const tmpDate: Date = this.fromNgbToDate(date)
    const tmpTime: Date = this.fromNgbToTime(time);
    tmpDate.setHours(tmpTime.getHours());
    tmpDate.setMinutes(tmpTime.getMinutes());
    tmpDate.setSeconds(tmpTime.getSeconds());
    tmpDate.setMilliseconds(999);
    return tmpDate;
  }

  ngOnInit(): void {
    this.log.trace(this._instanceId + " - Init component");
    if (!this.placement) {
      this.placement = 'bottom-right';
    }
    try {
      if (this._bowmanCacheService.has('algorilla_user')) {
        this._bowmanCacheService.get('algorilla_user').subscribe(user => {
          this.user = user;
          if (this.content != null) {
            TypeMappingComponent.getTypeMappingOverview(this._typeMappingService, this._bowmanCacheService).subscribe(typeMappingOverview => {
              this.parseDatePickerWidgetData();
              this.parsedTimeLabel = this.parseLabel(this.content);
              this.content = this.selectedTimeRange;
              this.contentChange.emit(this.selectedTimeRange);
              this.actionChange.emit(new Action(ActionTypesEnum.UPDATE_VIEW, this._instanceId));

              // Disabilitato perche qualsiasi timer fa scattare la changeDetection. Ciò vuol dire che per ogni TimeSelector presente nella sessione corrente, scatta un changeDetection ogni secondo.
              // Avvio il timer che tiene aggiornato il periodo temporale
              this._timer = timer(0, 1000);
              this.initTimepickerTimer(typeMappingOverview);
            }, err => {
              this._notificationService.error("Error occurred initializing Time Selector", err);
            });
          } else {
            this.parseDatePickerWidgetData();
            this.parsedTimeLabel = this.parseLabel(this.content);
            this.content = this.selectedTimeRange;
            this.contentChange.emit(this.selectedTimeRange);
            this.actionChange.emit(new Action(ActionTypesEnum.UPDATE_VIEW, this._instanceId));
          }
        });
      } else {
        this.user = null;
        this.log.error("Cannot get user information");
        this._cdr.detectChanges();
      }
    } catch (error) {
      this.log.error('Cannot initialize time selector component: ', error);
    }
  }

  private initTimepickerTimer(typeMappingOverview: TypeMappingOverview[]) {
    this._ngZone.runOutsideAngular(() => {
      if (this._timerSubscription) {
        this._timerSubscription.unsubscribe();
      }
      this._timerSubscription = this._timer.subscribe(() => {
        if (this.selectedTimeRange != null && this.selectedTimeRange.label != null && this.selectedTimeRange.label != 'All time' && this.popover && this.popover.isOpen()) {
          ControlBarTimeSelectorComponent.getIntervalFromLabel(this.selectedTimeRange.label, this.sourceTypes, typeMappingOverview, this.user.options['timeZone']).subscribe(timeRange => {
            this.parseNgbDateRange(timeRange);
            this.selectedTimeRange = timeRange;
            this.parsedTimeLabel = this.parseLabel(timeRange);
            this.content = timeRange;
            this.contentChange.emit(timeRange);
          });
        }
      });
    });
  }

  private parseDatePickerWidgetData() {
    try {
      this.selectedTimeRange = HelperFunctions.cloneObject(this.content);
      if (!this.isTimerangeValid(this.selectedTimeRange)) {
        // Se il timerange è null vuol dire che è stato selezionato "Use widgets defaults". In tutti gli altri casi imposta un timerange di default di "Last 15 minutes"
        if (this.selectedTimeRange == null) {
          this.parsedTimeLabel = 'Use widget default';
        }
        else {
          this.selectedTimeRange = new TimeRange(this.dateRangeIntervals.intervals[1].start.toDate(), this.dateRangeIntervals.intervals[1].end.toDate(), this.dateRangeIntervals.intervals[1].label);
          this.content = this.selectedTimeRange;
        }
      }
      else {
        // Se è valido sincronizza gli elementi del calendario
        if (this.selectedTimeRange != null && this.selectedTimeRange.label != null) {
          // C'è una label, quindi è un time relativo
          TypeMappingComponent.getTypeMappingOverview(this._typeMappingService, this._bowmanCacheService).subscribe(typeMappingOverview => {
            ControlBarTimeSelectorComponent.getIntervalFromLabel(this.selectedTimeRange.label, this.sourceTypes, typeMappingOverview).subscribe(timeRange => {
              this.selectedTimeRange = HelperFunctions.cloneObject(timeRange);
            });
          }, err => {
            this._notificationService.error("Errors occurred parsing time selector data", err);
          });
        }
        this.parseNgbDateRange(this.selectedTimeRange);
      }
    } catch (err) {
      this.log.error("Unable to parse DatePickerWidgetData: ", err)
    }
  }

  private parseLabel(timeRange: TimeRange): string {
    let label: string;
    try {
      if (!this.rangeDisabled) {
        if (timeRange && timeRange != null && timeRange.label != null) {
          label = timeRange.label;
        } else {
          if (timeRange && timeRange != null && timeRange.end != null && timeRange.start != null && this.fromDate.day != null && this.toDate != null) {
            timeRange.end = new Date(timeRange.end);
            timeRange.start = new Date(timeRange.start);
            const timeDifference: number = timeRange.end.getTime() - timeRange.start.getTime();
            const parsedDateFormat: string = this.user.options['dateFormat'].replace(/ HH:mm:ss/g, '').replace(/hh:mm:ss a/g, '').replace(/-/g, '');
            if (timeDifference <= (60 * 60 * 24) * 1000) { // Se la differenza è minore di un giorno  mostra solo gli orari
              label = this._datePipe.transform(timeRange.start, parsedDateFormat) + ' - ' + this._datePipe.transform(timeRange.start, 'HH:mm:ss') + ' to ' + this._datePipe.transform(timeRange.end, 'HH:mm:ss');
            } else { // Se la differenza è maggiore di un giorno e mezzo mostra solo i giorni senza l'ora
              label = this._datePipe.transform(timeRange.start, parsedDateFormat) + ' to ' + this._datePipe.transform(timeRange.end, parsedDateFormat);
            }
          } else {
            label = 'Use widget default';
          }
        }
      } else {
        if (timeRange && timeRange != null && timeRange.end != null && timeRange.start != null && this.fromDate.day != null && this.toDate != null) {
          timeRange.end = new Date(timeRange.end);
          timeRange.start = new Date(timeRange.start);
          const parsedDateFormat: string = this.user.options['dateFormat'].replace(/ HH:mm:ss/g, '').replace(/hh:mm:ss a/g, '').replace(/-/g, '');
          label = this._datePipe.transform(timeRange.start, parsedDateFormat) + ' - ' + this._datePipe.transform(timeRange.start, 'HH:mm:ss');
        }
      }
    } catch (error) {
      this.log.error('Cannot parse label from time selector: ', error);
    }
    return label;
  }
  public submitForm(zoomIn?: boolean, zoomOut?: boolean) {
    let aggregationInterval: number = (AggregationIntervalsEnum[Common.getBestAggregationInterval(10, new Date(this.content.start).getTime(), new Date(this.content.end).getTime())]) * 1000;
    if (typeof zoomIn != 'undefined' || typeof zoomOut != 'undefined') {
      if (zoomIn) {
        this.content.start = new Date(new Date(this.content.start).getTime() + aggregationInterval);
        this.content.end = new Date(new Date(this.content.end).getTime() - aggregationInterval);
      }
      if (zoomOut) {
        this.content.start = new Date(new Date(this.content.start).getTime() - aggregationInterval);
        this.content.end = new Date(new Date(this.content.end).getTime() + aggregationInterval);
      }
      this.actionChange.emit(new Action(ActionTypesEnum.DO_SEARCH, this._instanceId));
      this.selectedTimeRange = this.content;
      this.parseNgbDateRange(this.selectedTimeRange);
      this.parsedTimeLabel = this.parseLabel(this.selectedTimeRange);
      this._cdr.detectChanges();
    } else {
      this.actionChange.emit(new Action(ActionTypesEnum.DO_SEARCH, this._instanceId));
    }



  }
  ngOnDestroy() {
    if (this._timerSubscription) { this._timerSubscription.unsubscribe() }
  }

  ngOnChanges(changes: SimpleChanges): void {
    Object.keys(changes).filter(propName => propName == 'content').map(propName => {
      const change: SimpleChange = changes[propName];
      if (!change.isFirstChange() && JSON.stringify(change.currentValue) != JSON.stringify(change.previousValue)) {
        //this.log.trace(this._instanceId + " - Update view content changed");
        this.selectedTimeRange = this.content;
        this.parseNgbDateRange(this.selectedTimeRange);
        this.parsedTimeLabel = this.parseLabel(this.selectedTimeRange);
        this._cdr.detectChanges();
      }
    });
    Object.keys(changes).filter(propName => propName == 'action').map(propName => {
      const change: SimpleChange = changes[propName];
      if (!change.isFirstChange() && JSON.stringify(change.currentValue) != JSON.stringify(change.previousValue) && change.currentValue.type == ActionTypesEnum.UPDATE_VIEW) {
        this.log.trace(this._instanceId + " - Update view");
        this.selectedTimeRange = this.content;
        this.parseNgbDateRange(this.selectedTimeRange);
        this.parsedTimeLabel = this.parseLabel(this.selectedTimeRange);
        this._cdr.detectChanges();
      } else if (!change.isFirstChange() && JSON.stringify(change.currentValue) != JSON.stringify(change.previousValue) && change.currentValue.type == ActionTypesEnum.FLASH_TIME_SELECTOR) {
        this._renderer.addClass(this.timeSelectorElement.nativeElement, 'flash');
        setTimeout(() => {
          this._renderer.removeClass(this.timeSelectorElement.nativeElement, 'flash');
        }, 1500)
      }
    });
    Object.keys(changes).filter(propName => propName == 'sourceTypes').map(propName => {
      const change: SimpleChange = changes[propName];
      if (!change.isFirstChange() && JSON.stringify(change.currentValue) != JSON.stringify(change.previousValue)) {
        this.log.trace(this._instanceId + " - Update source types");
        TypeMappingComponent.getTypeMappingOverview(this._typeMappingService, this._bowmanCacheService).subscribe(typeMappingOverview => {
          ControlBarTimeSelectorComponent.getIntervalFromLabel(this.content.label, this.sourceTypes, typeMappingOverview).subscribe(timeRange => {
            this.selectedTimeRange = HelperFunctions.cloneObject(timeRange);
            this.parseNgbDateRange(this.selectedTimeRange);
            this.parsedTimeLabel = this.parseLabel(this.selectedTimeRange);
            this.contentChange.emit(this.content);
            this.actionChange.emit(new Action(ActionTypesEnum.UPDATE_VIEW, this._instanceId));
          });
        }, err => {
          this._notificationService.error("Errors occurred while updating source types in time selector", err);
        });
      }
    });
  }
}

export class ControlBarTimeSelectorChange {
  id: string;
  from: number;
  to: number;
  label: string;
  doSearch: boolean;
  constructor(id: string, from: number, to: number, label: string, doSearch: boolean) {
    this.id = id;
    this.from = from;
    this.to = to;
    this.label = label;
    this.doSearch = doSearch;
  }
}
